import React from 'react';
import GuidedCampaignReview from './components/GuidedCampaignReview.js';
import connect from './connect';
import './assets/GuidedCampaignReview.css';

import { Elements } from 'react-stripe-elements'; 


const Component = connect(GuidedCampaignReview);

const ComponentWithElements = (props) => (
  <Elements>
    <Component {...props} />
  </Elements>
);

export default ComponentWithElements;




// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/index.js